import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { alerts } from '../data/mockData';

const Alerts = () => {
  const [filter, setFilter] = useState('All');

  const filteredAlerts = filter === 'All' 
    ? alerts 
    : alerts.filter(a => a.type === filter);

  const getSeverityColor = (severity) => {
    switch(severity) {
      case 'High': return 'bg-red-100 text-red-800 border-red-200';
      case 'Medium': return 'bg-orange-100 text-orange-800 border-orange-200';
      default: return 'bg-blue-100 text-blue-800 border-blue-200';
    }
  };

  return (
    <div className="container-custom py-8 min-h-screen">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Safety Alerts & Recalls</h1>
        <p className="text-gray-600">Official notifications regarding moringa product safety, recalls, and regulatory actions.</p>
      </div>

      {/* Filters */}
      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {['All', 'Recall', 'Outbreak', 'Warning'].map(type => (
          <button
            key={type}
            onClick={() => setFilter(type)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
              filter === type 
                ? 'bg-primary text-white' 
                : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {type}
          </button>
        ))}
      </div>

      {/* Alerts List */}
      <div className="space-y-4">
        {filteredAlerts.map(alert => (
          <div key={alert.id} className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden">
            <div className={`absolute top-0 left-0 w-1 h-full ${
              alert.severity === 'High' ? 'bg-alert' : 'bg-yellow-500'
            }`}></div>
            
            <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 pl-2">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded border ${getSeverityColor(alert.severity)}`}>
                    {alert.severity} Priority
                  </span>
                  <span className="text-xs text-gray-500 flex items-center gap-1">
                    <SafeIcon icon={FiIcons.FiCalendar} /> {alert.date}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {alert.title}
                </h3>
                <p className="text-gray-600 text-sm mb-3">
                  {alert.summary}
                </p>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="font-semibold text-gray-700">Source: {alert.brand}</span>
                  <span>Status: {alert.status}</span>
                </div>
              </div>
              
              <a 
                href={alert.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="self-start md:self-center px-4 py-2 text-sm font-medium text-primary border border-primary rounded hover:bg-primary hover:text-white transition-colors flex items-center gap-2"
              >
                Read Official Notice <SafeIcon icon={FiIcons.FiExternalLink} />
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Social Section */}
      <div className="mt-12 p-8 bg-gray-50 rounded-xl border border-gray-200 text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Social Media Updates</h2>
        <p className="text-gray-600 mb-6">Follow the latest visual alerts and community reports on Instagram.</p>
        <a 
          href="https://www.instagram.com/p/DUtYIEejwor/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#E1306C] text-white px-6 py-2 rounded-lg font-bold hover:opacity-90 transition-opacity"
        >
          <SafeIcon icon={FiIcons.FiInstagram} /> View Instagram Alert
        </a>
      </div>
    </div>
  );
};

export default Alerts;